// Compatibility barrel for imports from '@angular/material'.
// Angular Material 17 removed @angular/material/legacy-*. These re-exports
// keep existing `from '@angular/material'` compile paths on the MDC APIs.
export { MatAutocompleteModule } from '@angular/material/autocomplete';
export { MatBadgeModule } from '@angular/material/badge';
export { MatBottomSheetModule } from '@angular/material/bottom-sheet';
export { MatButtonModule } from '@angular/material/button';
export { MatButtonToggleModule } from '@angular/material/button-toggle';
export { MatCardModule } from '@angular/material/card';
export { MatCheckboxModule } from '@angular/material/checkbox';
export { MatChipsModule } from '@angular/material/chips';
export { MatNativeDateModule, MatOptionModule, MatRippleModule } from '@angular/material/core';
export { MatDatepickerModule } from '@angular/material/datepicker';
export {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
export { MatDividerModule } from '@angular/material/divider';
export { MatExpansionModule } from '@angular/material/expansion';
export {
  MatFormFieldModule,
  MatLabel,
  MatError,
  MatHint
} from '@angular/material/form-field';
export { MatGridListModule } from '@angular/material/grid-list';
export { MatIconModule } from '@angular/material/icon';
export { MatInputModule } from '@angular/material/input';
export { MatListModule } from '@angular/material/list';
export { MatMenuModule } from '@angular/material/menu';
export { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
export { MatProgressBarModule } from '@angular/material/progress-bar';
export {
  MatProgressSpinner,
  MatProgressSpinnerModule,
  MatSpinner
} from '@angular/material/progress-spinner';
export { MatRadioModule } from '@angular/material/radio';
export { MatSelect, MatSelectModule } from '@angular/material/select';
export { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
export { MatSlideToggleModule } from '@angular/material/slide-toggle';
export { MatSliderModule } from '@angular/material/slider';
export {
  MatSnackBar,
  MatSnackBarModule,
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
  MatSnackBarContainer
} from '@angular/material/snack-bar';
export { MatSort, MatSortModule, Sort } from '@angular/material/sort';
export { MatStepperModule } from '@angular/material/stepper';
export { MatTableDataSource, MatTableModule } from '@angular/material/table';
export { MatTabsModule } from '@angular/material/tabs';
export { MatToolbarModule } from '@angular/material/toolbar';
export { MatTooltipModule } from '@angular/material/tooltip';
export { MatTreeModule } from '@angular/material/tree';
